import Button from '@gaia/components/Button';
import theme from '@gaia/theme';
import {Typography} from '@mui/material';

export default function LayersExplained({
    setStepCount,
    onSidebarChange,
}: {
    setStepCount: SetState<number>;
    onSidebarChange: SetState<SidebarState>;
}) {
    return (
        <div>
            <Typography variant='h5' style={{marginTop: theme.spacing(2)}}>
                Add and view different maps.
            </Typography>
            <Typography variant='body1' style={{margin: theme.spacing(1)}}>
                Click the layers icon to change the visible map. Depending on the area or activity
                you are doing, you may find a different map with information you need.
            </Typography>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginTop: theme.spacing(2),
                }}
            >
                <Button
                    appearance='secondary'
                    onClick={() => setStepCount((prevState: number) => prevState - 1)}
                >
                    Back
                </Button>
                <Button
                    appearance='primary'
                    onClick={() => {
                        onSidebarChange({type: 'hidden'});
                        setStepCount((prevState: number) => prevState + 1);
                    }}
                >
                    Next
                </Button>
            </div>
        </div>
    );
}
